<template>
  <div class="bg-background-neutral-primary space-y-4 p-4">
    <div
      class="bg-background-neutral-secondary space-y-4 rounded-3xl px-4 pt-4 shadow-[0px_5px_10px_rgba(0,0,0,0.05)]"
    >
      <div class="space-y-2">
        <div class="shimmer h-4 w-40 rounded-xl" />
        <div class="shimmer h-8 w-14 rounded-xl" />
      </div>
      <div class="border-situational-lightgrey border-t" />
      <div class="flex items-center gap-3 pb-4">
        <div class="shimmer h-10 w-10 shrink-0 rounded-2xl" />
        <div class="flex flex-1 flex-col gap-1.5">
          <div class="shimmer h-4 w-28 rounded-xl" />
          <div class="shimmer h-3.5 w-24 rounded-xl" />
          <div class="shimmer h-3.5 w-16 rounded-xl" />
        </div>
        <div class="shimmer h-7 w-12 rounded-full" />
      </div>
    </div>

    <div
      class="bg-background-neutral-secondary space-y-4 rounded-3xl p-4 shadow-[0px_5px_20px_rgba(0,0,0,0.05)]"
    >
      <div class="space-y-2">
        <div class="shimmer h-3.5 w-40 rounded-xl" />
        <div class="shimmer h-6 w-44 rounded-xl" />
      </div>
      <div class="shimmer h-4 w-full rounded-full" />
      <div class="border-situational-lightgrey border-t" />
      <div class="space-y-1.5">
        <div class="shimmer h-3.5 w-52 rounded-xl" />
        <div class="shimmer h-5 w-32 rounded-xl" />
      </div>
    </div>

    <div class="shimmer h-12 rounded-3xl" />

    <div class="space-y-4">
      <div
        class="bg-background-neutral-secondary flex items-center justify-between rounded-[20px] p-4"
      >
        <div class="shimmer h-5 w-52 rounded-xl" />
        <div class="shimmer h-5 w-5 rounded-md" />
      </div>
      <div
        class="bg-background-neutral-secondary flex items-center justify-between rounded-[20px] p-4"
      >
        <div class="shimmer h-5 w-40 rounded-xl" />
        <div class="shimmer h-5 w-5 rounded-md" />
      </div>
    </div>

    <div class="shimmer h-14 w-full rounded-2xl" />
  </div>
</template>
